import { 
  zlbCostControlBdBasicDataCategoryListGet,
  zlbCostControlBdBasicDataSaveCategoryPost,
  zlbCostControlBdBasicDataDeleteCategoryCategoryCodePost,
  zlbCostControlBdBasicDataDataGroupPagePost,
  zlbCostControlBdBasicDataSaveDataGroupPost,
  zlbCostControlBdBasicDataChangeGroupStatusPost,
  zlbCostControlBdBasicDataDeleteGroupGroupCodePost,
  zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGet,
  zlbCostControlBdBasicDataDataGroupDetailGroupCodeGet,
} from '@/api/zlbCostControl';
    
export default {
  namespace: 'FeeItemBasicData',
  state: {},
  effects: {
    // 数据组分类列表
    * getBasicDataCategoryList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataCategoryListGet, payload);
      return res;
    },
    // 数据组分类详情
    * getBasicDataCategoryDetail ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataCategoryDetailGroupCategoryCodeGet, payload);
      return res;
    },
    // 数据组分类保存
    * saveBasicDataCategory ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataSaveCategoryPost, payload);
      return res;
    },
    // 删除数据组分类
    * deleteBasicDataCategory ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataDeleteCategoryCategoryCodePost, payload);
      return res;
    },
    // 基础数据组分页查询
    * getBasicDataList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataDataGroupPagePost, payload);
      return res;
    },
    // 基础数据组详情
    * getBasicDataDetail ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataDataGroupDetailGroupCodeGet, payload);
      return res;
    },
    // 基础数据组保存
    * saveBasicData ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataSaveDataGroupPost, payload);
      return res;
    },
    // 基础数据停启用
    * changeBasicDataStatus ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataChangeGroupStatusPost, payload);
      return res;
    },
    // 基础数据删除
    * deleteBasicData ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdBasicDataDeleteGroupGroupCodePost, payload);
      return res;
    },
  },
       
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
    